import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { splitFiltersFromQueryParamString } from "@faire/retailer-shared/filters/splitFiltersFromQueryParams";
import qs from "query-string";
export var BRAND_PAGE_SAMPLE_REQUEST_MODAL_TYPE = "sampleRequest";
export var BRAND_PAGE_REQUEST_EXCLUSIVITY_MODAL_TYPE = "requestExclusivity";
export var BRAND_PAGE_REQUEST_EXCLUSIVITY_SPEND_REMINDER_MODAL_TYPE = "requestExclusivitySpendReminder";
export var BRAND_PAGE_STORY_MODAL_TYPE = "story";
export function parseBrandPageQueryObj(locationSearch) {
    if (!locationSearch) {
        return {};
    }
    var queryObj = qs.parse(locationSearch);
    if (typeof queryObj.refF === "string") {
        queryObj.refF = [
            queryObj.refF
        ];
    }
    if (typeof queryObj.refP === "string") {
        queryObj.refP = [
            queryObj.refP
        ];
    }
    // checking the type to avoid a fatal error if filters is duplicated in the url
    if (queryObj.filters && typeof queryObj.filters === "string") {
        var _splitFiltersFromQueryParamString;
        queryObj.filters = (_splitFiltersFromQueryParamString = splitFiltersFromQueryParamString(queryObj.filters)) !== null && _splitFiltersFromQueryParamString !== void 0 ? _splitFiltersFromQueryParamString : [];
    }
    return _object_spread_props(_object_spread({}, queryObj), {
        sortingHint: parseBoolean(queryObj.sortingHint),
        scrollToGrid: parseBoolean(queryObj.scrollToGrid),
        collections: parseBoolean(queryObj.collections),
        minimumAmountFooter: parseBoolean(queryObj.minimumAmountFooter),
        page: parsePageNumber(queryObj.page)
    });
}
function parsePageNumber(page) {
    if (typeof page === "string") {
        var pageNumber = parseInt(page, 10);
        if (isFinite(pageNumber)) {
            return pageNumber;
        }
    }
    return undefined;
}
function parseBoolean(value) {
    if (value === undefined || value === null) {
        return undefined;
    } else {
        return Boolean(value);
    }
}
